package com.isaias.fyattravel.shared.Visa

object CountryCodes {
    // Split large map into smaller chunks to avoid "string too large" warning
    private val countriesA_D = mapOf(
        "AF" to "Afghanistan",
        "AL" to "Albania",
        "DZ" to "Algeria",
        "AS" to "American Samoa",
        "AD" to "Andorra",
        "AO" to "Angola",
        "AI" to "Anguilla",
        "AQ" to "Antarctica",
        "AG" to "Antigua and Barbuda",
        "AR" to "Argentina",
        "AM" to "Armenia",
        "AW" to "Aruba",
        "AU" to "Australia",
        "AT" to "Austria",
        "AZ" to "Azerbaijan",
        "BS" to "Bahamas",
        "BH" to "Bahrain",
        "BD" to "Bangladesh",
        "BB" to "Barbados",
        "BY" to "Belarus",
        "BE" to "Belgium",
        "BZ" to "Belize",
        "BJ" to "Benin",
        "BM" to "Bermuda",
        "BT" to "Bhutan",
        "BO" to "Bolivia",
        "BA" to "Bosnia and Herzegovina",
        "BW" to "Botswana",
        "BR" to "Brazil",
        "IO" to "British Indian Ocean Territory",
        "BN" to "Brunei Darussalam",
        "BG" to "Bulgaria",
        "BF" to "Burkina Faso",
        "BI" to "Burundi",
        "KH" to "Cambodia",
        "CM" to "Cameroon",
        "CA" to "Canada",
        "CV" to "Cape Verde",
        "KY" to "Cayman Islands",
        "CF" to "Central African Republic",
        "TD" to "Chad",
        "CL" to "Chile",
        "CN" to "China",
        "CO" to "Colombia",
        "KM" to "Comoros",
        "CG" to "Congo",
        "CD" to "Congo, Democratic Republic",
        "CK" to "Cook Islands",
        "CR" to "Costa Rica",
        "CI" to "Cote D'Ivoire",
        "HR" to "Croatia",
        "CU" to "Cuba",
        "CY" to "Cyprus",
        "CZ" to "Czech Republic",
        "DK" to "Denmark",
        "DJ" to "Djibouti",
        "DM" to "Dominica",
        "DO" to "Dominican Republic"
    )

    private val countriesE_K = mapOf(
        "EC" to "Ecuador", "EG" to "Egypt", "SV" to "El Salvador", "GQ" to "Equatorial Guinea",
        "ER" to "Eritrea", "EE" to "Estonia", "ET" to "Ethiopia", "FK" to "Falkland Islands",
        "FO" to "Faroe Islands", "FJ" to "Fiji", "FI" to "Finland", "FR" to "France",
        "GF" to "French Guiana", "PF" to "French Polynesia", "GA" to "Gabon", "GM" to "Gambia",
        "GE" to "Georgia", "DE" to "Germany", "GH" to "Ghana", "GI" to "Gibraltar",
        "GR" to "Greece", "GL" to "Greenland", "GD" to "Grenada", "GP" to "Guadeloupe",
        "GU" to "Guam", "GT" to "Guatemala", "GN" to "Guinea", "GW" to "Guinea-Bissau",
        "GY" to "Guyana", "HT" to "Haiti", "HN" to "Honduras", "HK" to "Hong Kong",
        "HU" to "Hungary", "IS" to "Iceland", "IN" to "India", "ID" to "Indonesia",
        "IR" to "Iran", "IQ" to "Iraq", "IE" to "Ireland", "IL" to "Israel",
        "IT" to "Italy", "JM" to "Jamaica", "JP" to "Japan", "JO" to "Jordan",
        "KZ" to "Kazakhstan", "KE" to "Kenya", "KI" to "Kiribati", "KP" to "North Korea",
        "KR" to "South Korea", "KW" to "Kuwait", "KG" to "Kyrgyzstan"
    )

    private val countriesL_P = mapOf(
        "LA" to "Laos", "LV" to "Latvia", "LB" to "Lebanon", "LS" to "Lesotho",
        "LR" to "Liberia", "LY" to "Libya", "LI" to "Liechtenstein", "LT" to "Lithuania",
        "LU" to "Luxembourg", "MO" to "Macao", "MG" to "Madagascar", "MW" to "Malawi",
        "MY" to "Malaysia", "MV" to "Maldives", "ML" to "Mali", "MT" to "Malta",
        "MH" to "Marshall Islands", "MQ" to "Martinique", "MR" to "Mauritania", "MU" to "Mauritius",
        "YT" to "Mayotte", "MX" to "Mexico", "FM" to "Micronesia", "MD" to "Moldova",
        "MC" to "Monaco", "MN" to "Mongolia", "MS" to "Montserrat", "MA" to "Morocco",
        "MZ" to "Mozambique", "MM" to "Myanmar", "NA" to "Namibia", "NR" to "Nauru",
        "NP" to "Nepal", "NL" to "Netherlands", "NC" to "New Caledonia", "NZ" to "New Zealand",
        "NI" to "Nicaragua", "NE" to "Niger", "NG" to "Nigeria", "NU" to "Niue",
        "NF" to "Norfolk Island", "MP" to "Northern Mariana Islands", "NO" to "Norway",
        "OM" to "Oman", "PK" to "Pakistan", "PW" to "Palau", "PS" to "Palestine",
        "PA" to "Panama", "PG" to "Papua New Guinea", "PY" to "Paraguay", "PE" to "Peru",
        "PH" to "Philippines", "PN" to "Pitcairn", "PL" to "Poland", "PT" to "Portugal",
        "PR" to "Puerto Rico"
    )

    private val countriesQ_Z = mapOf(
        "QA" to "Qatar",
        "RE" to "Reunion",
        "RO" to "Romania",
        "RU" to "Russia",
        "RW" to "Rwanda",
        "SH" to "Saint Helena",
        "KN" to "Saint Kitts and Nevis",
        "LC" to "Saint Lucia",
        "PM" to "Saint Pierre and Miquelon",
        "VC" to "Saint Vincent and the Grenadines",
        "WS" to "Samoa",
        "SM" to "San Marino",
        "ST" to "Sao Tome and Principe",
        "SA" to "Saudi Arabia",
        "SN" to "Senegal",
        "SC" to "Seychelles",
        "SL" to "Sierra Leone",
        "SG" to "Singapore",
        "SK" to "Slovakia",
        "SI" to "Slovenia",
        "SB" to "Solomon Islands",
        "SO" to "Somalia",
        "ZA" to "South Africa",
        "ES" to "Spain",
        "LK" to "Sri Lanka",
        "SD" to "Sudan",
        "SR" to "Suriname",
        "SZ" to "Swaziland",
        "SE" to "Sweden",
        "CH" to "Switzerland",
        "SY" to "Syria",
        "TW" to "Taiwan",
        "TJ" to "Tajikistan",
        "TZ" to "Tanzania",
        "TH" to "Thailand",
        "TG" to "Togo",
        "TK" to "Tokelau",
        "TO" to "Tonga",
        "TT" to "Trinidad and Tobago",
        "TN" to "Tunisia",
        "TR" to "Turkey",
        "TM" to "Turkmenistan",
        "TC" to "Turks and Caicos Islands",
        "TV" to "Tuvalu",
        "UG" to "Uganda",
        "UA" to "Ukraine",
        "AE" to "United Arab Emirates",
        "GB" to "United Kingdom",
        "US" to "United States",
        "UY" to "Uruguay",
        "UZ" to "Uzbekistan",
        "VU" to "Vanuatu",
        "VE" to "Venezuela",
        "VN" to "Vietnam",
        "VG" to "Virgin Islands, British",
        "VI" to "Virgin Islands, U.S.",
        "WF" to "Wallis and Futuna",
        "EH" to "Western Sahara",
        "YE" to "Yemen",
        "ZM" to "Zambia",
        "ZW" to "Zimbabwe"
    )

    // Combine all chunks into one map
    val countries: Map<String, String> by lazy {
        countriesA_D + countriesE_K + countriesL_P + countriesQ_Z
    }

    fun getCountryCode(countryName: String): String? {
        return countries.entries.find {
            it.value.equals(countryName, ignoreCase = true)
        }?.key
    }

    fun getCountryName(countryCode: String): String? {
        return countries[countryCode.uppercase()]
    }

    fun searchCountries(query: String): List<Pair<String, String>> {
        return if (query.isBlank()) {
            countries.toList().sortedBy { it.second }
        } else {
            countries.filter {
                it.value.contains(query, ignoreCase = true) ||
                        it.key.contains(query, ignoreCase = true)
            }.toList().sortedBy { it.second }
        }
    }
}